// extracted by mini-css-extract-plugin
module.exports = {"container":"AreaInfo_container__3IBX3","areaName":"AreaInfo_areaName__PCOqz","address":"AreaInfo_address___UYsx"};